import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const PowerBI = () => {
  const user = useSelector((state) => state.userDetails.value);
  //const [powerBIUrl, setPowerBIUrl] = useState("https://app.powerbi.com/reportEmbed?reportId=aa681b6c-a8c0-4533-8740-16c516e33e2c&autoAuth=true&ctid=a18515c2-3198-4fad-97ed-29a46c974fdb%22&clientSideAuth=0&fallbackError=%7B%22flow%22%3A%22Reportembed%22%2C%22source%22%3A%22User%22%2C%22info%22%3A%22endpoints_resolution_error%3A+Error%3A+could+not+resolve+endpoints.+Please+check+network+and+try+again.+Detail%3A+ClientAuthError%3A+openid_config_error%3A+Could+not+retrieve+endpoints.+Check+your+authority+and+verify+the+.well-known%2Fopenid-configuration+endpoint+returns+the+required+endpoints.+Attempted+to+retrieve+endpoints+from%3A+https%3A%2F%2Flogin.microsoftonline.com%2Fa18515c2-3198-4fad-97ed-29a46c974fdb%5C%22%2Fv2.0%2F.well-known%2Fopenid-configuration%22%2C%22code%22%3A%22endpoints_resolution_error%22%7D");
  const [powerBIUrl, setPowerBIUrl] = useState("https://app.powerbi.com/reportEmbed?reportId=f10621af-759c-4d30-8662-9a78b42c19a9&appId=8421ffb4-a921-4fbc-855f-f029ecd3ee16&autoAuth=true&ctid=a18515c2-3198-4fad-97ed-29a46c974fdb");
 // const [isLoading, setIsLoading] = useState(true);
  let email;

  useEffect(() => {
    if (user?.UserRole === "Client") {
      email = user?.emailId;
    } else {
      email = user?.UD_emp_email;
    }
   
  }, []);

  return (
    <div className="card rounded-0 border-0 overflow-auto h-100 w-100 d-flex align-items-center justify-content-center">
      {/* {isLoading ? (
        <>
          <Spinner />
          <iframe
            className="d-none"
            src={powerBIUrl}
            title="Sisense Dashboard"
            width="100%"
            height="100%"
            onLoad={() => setIsLoading(false)}
          /> 
        </>
      ) : (
        powerBIUrl && ( */}
          <>
            <iframe
              src={powerBIUrl}
              title="PowerBI Dashboard"
              width="100%"
              height="100%"
            />
          </>
        {/* )
      )} */}
    </div>
  );
};

export default PowerBI;
